import axios from 'axios';
import { GET_CABLE_API_URL, GET_CABLE_TYPE_API_URL, GET_COUPLING_API_URL,
    GET_FOB_API_URL, GET_CONTRACTOR_API_URL, GET_RANK_CABLE_API_URL,
    GET_RANK_COMPONENT_API_URL, GET_OWNER_WELL_API_URL, GET_OWNER_PILLAR_API_URL, GET_PON_BOX_API_URL,
    GET_KTV_AMPLIFIER_API_URL,
    GET_KTV_OP_API_URL,
    GET_PON_BOX_COMING_API_URL,
    GET_PROBLEM_TYPE_CABLE_API_URL,
    GET_DIVIDER_API_URL,
    GET_CASSETTE_API_URL,
    GET_BOX_COUSTRUCTION_API_URL,
    GET_POLISHING_COUSTRUCTION_API_URL,
    GET_RESERVE_API_URL} from '../OpticApiConfig';


 //загрузка выдов кабеля
 export const loadingCableDataComponent  = async () => {
    try {
        const token = localStorage.getItem('token');
        const resultCable = await axios.get(GET_CABLE_API_URL,{
            headers:{
                'Authorization': `Bearer ${token}` 
              }
        });
        return resultCable.data;
    } catch (error) {
       // console.error("Error fetching cable data:", error);
        throw error;
    }
  };

 // загрузка типов кабеля
  export const loadingCableTypeDataComponent  = async () => {
    try {
        const token = localStorage.getItem('token');
        const resultCableType = await axios.get(GET_CABLE_TYPE_API_URL,{
            headers:{
                'Authorization': `Bearer ${token}` 
              }
        });
        return resultCableType.data;
    } catch (error) {
       // console.error("Error fetching CableType data:", error);
        throw error;
    }
  };

   //загрузка муфт
   export const loadingCouplingDataComponent  = async () => {
    try {
        const token = localStorage.getItem('token');
        const resultCoupling = await axios.get(GET_COUPLING_API_URL,{
            headers:{
                'Authorization': `Bearer ${token}` 
              }
        });
        return resultCoupling.data;
    } catch (error) {
       // console.error("Error fetching Coupling data:", error);
        throw error;
    }
  };

    //загрузка Фоб
    export const loadingFobDataComponent  = async () => {
        try {
            const token = localStorage.getItem('token');
            const resultFob = await axios.get(GET_FOB_API_URL, {
                headers:{
                    'Authorization': `Bearer ${token}` 
                  } 
            });
            return resultFob.data;
        } catch (error) {
           // console.error("Error fetching Coupling data:", error);
            throw error;
        }
    };

        //загрузка Делителей
        export const loadingDividerDataComponent  = async () => {
            try {
                const token = localStorage.getItem('token');
                const resultDivider = await axios.get(GET_DIVIDER_API_URL, {
                    headers:{
                        'Authorization': `Bearer ${token}` 
                      } 
                });
                return resultDivider.data;
            } catch (error) {
               // console.error("Error fetching Coupling data:", error);
                throw error;
            }
        };

         //загрузка BOX
        export const loadingBoxDataComponent  = async () => {
            try {
                const token = localStorage.getItem('token');
                const resultBox = await axios.get(GET_BOX_COUSTRUCTION_API_URL, {
                    headers:{
                        'Authorization': `Bearer ${token}` 
                      } 
                });
                return resultBox.data;
            } catch (error) {
               // console.error("Error fetching Coupling data:", error);
                throw error;
            }
        };

          //загрузка Polishing
        export const loadingPolishingDataComponent  = async () => {
            try {
                const token = localStorage.getItem('token');
                const resultPolishing = await axios.get(GET_POLISHING_COUSTRUCTION_API_URL, {
                    headers:{
                        'Authorization': `Bearer ${token}` 
                      } 
                });
                return resultPolishing.data;
            } catch (error) {
               // console.error("Error fetching Coupling data:", error);
                throw error;
            }
        };


         //загрузка Кассет
         export const loadingCassetteDataComponent  = async () => {
            try {
                const token = localStorage.getItem('token');
                const resultCassette = await axios.get(GET_CASSETTE_API_URL, {
                    headers:{
                        'Authorization': `Bearer ${token}` 
                      } 
                });
                return resultCassette.data;
            } catch (error) {
               // console.error("Error fetching Coupling data:", error);
                throw error;
            }
        };

     //загрузка KtvAmplifier
     export const loadingKtvAmplifierDataComponent  = async () => {
        try {
            const token = localStorage.getItem('token');
            const resultKtv = await axios.get(GET_KTV_AMPLIFIER_API_URL, {
                headers:{
                    'Authorization': `Bearer ${token}` 
                  } 
            });
            return resultKtv.data;
        } catch (error) {
           // console.error("Error fetching Coupling data:", error);
            throw error;
        }
    };

     //загрузка ИБП
     export const loadingReserveDataComponent  = async () => {
        try {
            const token = localStorage.getItem('token');
            const resultReserve = await axios.get(GET_RESERVE_API_URL, {
                headers:{
                    'Authorization': `Bearer ${token}` 
                  } 
            });
            return resultReserve.data;
        } catch (error) {
           // console.error("Error fetching Coupling data:", error);
            throw error;
        }
    };

    //загрузка OP
    export const loadingOpDataComponent  = async () => {
        try {
            const token = localStorage.getItem('token');
            const resultKtv = await axios.get(GET_KTV_OP_API_URL, {
                headers:{
                    'Authorization': `Bearer ${token}` 
                  } 
            });
            return resultKtv.data;
        } catch (error) {
           // console.error("Error fetching Coupling data:", error);
            throw error;
        }
    };

    //загрузка Pon-box
    export const loadingPonBoxDataComponent  = async () => {
        try {
            const token = localStorage.getItem('token');
            const resultPonBox = await axios.get(GET_PON_BOX_API_URL, {
                headers:{
                    'Authorization': `Bearer ${token}` 
                  } 
            });
            return resultPonBox.data;
        } catch (error) {
           // console.error("Error fetching Coupling data:", error);
            throw error;
        }
    };

     //загрузка Pon-box Coming
     export const loadingPonBoxComingDataComponent  = async () => {
        try {
            const token = localStorage.getItem('token');
            const resultPonBox = await axios.get(GET_PON_BOX_COMING_API_URL, {
                headers:{
                    'Authorization': `Bearer ${token}` 
                  } 
            });
            return resultPonBox.data;
        } catch (error) {
           // console.error("Error fetching Coupling data:", error);
            throw error;
        }
    };

    //загрузка Подрядчик
    export const loadingContractorDataComponent  = async () => {
        try {
            const token = localStorage.getItem('token');
            const resultContractor = await axios.get(GET_CONTRACTOR_API_URL, {
                headers:{
                    'Authorization': `Bearer ${token}` 
                  }
            });
            return resultContractor.data;
        } catch (error) {
        // console.error("Error fetching Coupling data:", error);
            throw error;
        }
    };

    //загрузка RankCable
    export const loadingRankCableDataComponent  = async () => {
        try {
            const token = localStorage.getItem('token');
            const resultRankCable = await axios.get(GET_RANK_CABLE_API_URL, {
                headers:{
                    'Authorization': `Bearer ${token}` 
                  } 
            });
            return resultRankCable.data;
        } catch (error) {
        // console.error("Error fetching Coupling data:", error);
            throw error;
        }
    };

      //загрузка RancComponent
      export const loadingRankComponentDataComponent  = async () => {
        try {
            const token = localStorage.getItem('token');
            const resultRancComponent = await axios.get(GET_RANK_COMPONENT_API_URL, {
                headers:{
                    'Authorization': `Bearer ${token}` 
                  }
            });
            return resultRancComponent.data;
        } catch (error) {
           // console.error("Error fetching Coupling data:", error);
            throw error;
        }
    };

          //загрузка OwnerWell
      export const loadingOwnerWellDataComponent  = async () => {
        try {
            const token = localStorage.getItem('token');
            const resultOwnerWellComponent = await axios.get(GET_OWNER_WELL_API_URL, {
                headers:{
                    'Authorization': `Bearer ${token}` 
                  } 
            });
            return resultOwnerWellComponent.data;
        } catch (error) {
           // console.error("Error fetching Coupling data:", error);
            throw error;
        }
    };

     //загрузка OwnerPillar
     export const loadingOwnerPillarDataComponent  = async () => {
        try {
            const token = localStorage.getItem('token');
            const resultOwnerPillarComponent = await axios.get(GET_OWNER_PILLAR_API_URL, {
                headers:{
                    'Authorization': `Bearer ${token}` 
                  }  
            });
            return resultOwnerPillarComponent.data;
        } catch (error) {
           // console.error("Error fetching Coupling data:", error);
            throw error;
        }
    };

    //загрузка ProblemType
    export const loadingProblemTypeDataComponent  = async () => {
        try {
            const token = localStorage.getItem('token');
            const resultProblem = await axios.get(GET_PROBLEM_TYPE_CABLE_API_URL, {
                headers:{
                    'Authorization': `Bearer ${token}` 
                  } 
            });
            return resultProblem.data;
        } catch (error) {
           // console.error("Error fetching Coupling data:", error);
            throw error;
        }
    };

 





 